<div class="tw-flex tw-items-center tw-justify-between tw-mb-3">
  <div
    *ngIf="userDetails$ | async as userDetails"
    class="tw-flex tw-items-center tw-gap-2.5"
  >
    <img alt="User Avatar" class="tw-w-10 tw-h-10 tw-rounded-full tw-object-cover" [src]="userAvatar$ | async" />
    <div class="tw-flex tw-flex-col">
      <span class="tw-mt-0.5 tw-font-bold tw-leading-5">{{ userDetails.firstName }} {{ userDetails.lastName }}</span>
      <span class="tw-text-sm">{{ userDetails.email }}</span>
    </div>
  </div>
  <div
    kendoTooltip class="tw-flex tw-flex-col tw-items-end tw-min-w-[90px]"
    title="{{ 'student.profile.labels.balance' | translate }}"
  >
    <span class="tw-flex tw-items-center">
      <fa-icon class="tw-mr-2" [icon]="icons.faWallet"></fa-icon>
      <span class="tw-text-xl tw-font-bold">
        {{ currencySign$ | async }}{{ studentBalanceString$ | async }}
      </span>
    </span>
    <div
      class="tw-flex tw-justify-end tw-items-center tw-gap-1 hover:tw-cursor-pointer tw-text-sm tw-hidden"
    >
      <span class="tw-underline">Claim</span>
      <fa-icon [icon]="icons.faArrowUpRightFromSquare"></fa-icon>
    </div>
  </div>
</div>
